import PropTypes from 'prop-types';
import Button from '~/components/Button';
import ErrorPage from '~/components/ErrorPage';

export const Error403 = ({
  backLink = '/',
  children,
  subHeading = "You dont't have access to this content",
}) => {
  return (
    <ErrorPage>
      <ErrorPage.MainContent>
        <ErrorPage.Heading>This content is unavailable</ErrorPage.Heading>

        <ErrorPage.Subheading>{subHeading}</ErrorPage.Subheading>

        {children && <ErrorPage.Text>{children}</ErrorPage.Text>}

        <Button as="a" href={backLink} colorScheme="primary">
          Back
        </Button>
      </ErrorPage.MainContent>

      <ErrorPage.Image
        accentColor="#D5D5DD"
        srcSet="/images/403_img.png, /images/403_imgx2.png 2x, /images/403_imgx3.png 3x"
      />
    </ErrorPage>
  );
};

Error403.propTypes = {
  backLink: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  subHeading: PropTypes.string,
};

Error403.defaultProps = {
  backLink: '/',
  subHeading: "You don't have access to this content",
};
